import { createCookie, readCookie, eraseCookie } from './cookies';

// ICONS
var iconCloseX = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 1000 1000" style="enable-background:new 0 0 1000 1000;" xml:space="preserve">
   <polygon points="1000,49.1 950.9,0 500,450.9 49.1,0 0,49.1 450.9,500 0,950.9 49.1,1000 500,549.1 950.9,1000 1000,950.9 
  549.1,500 "/>
  </svg>`;


// OVERLAY LINK CLICK
const body = document.querySelector("body");
var modal = document.getElementById('modal');
var modalContent = document.getElementById('modal-content');


const overlayLinks = document.querySelectorAll("[data-overlay]");
if(overlayLinks){
    overlayLinks.forEach(overlayLink => {
        overlayLink.addEventListener('click',event=>{
            event.preventDefault();
            openOverlay(overlayLink);
        });
    });
}

const modalClose = document.querySelector(".modal__close");
if(modalClose){
    modalClose.addEventListener('click',event=>{
        event.preventDefault();
        closeOverlay()
    });
}

function openOverlay(link){ 
  var openDelay = loadOverlayHtml(link);
  setTimeout(function(){
    body.classList.add("no-scroll");
    modal.setAttribute('open','true');
  },openDelay);
}

function closeOverlay(){
  body.classList.remove("no-scroll");
  modal.removeAttribute('open');
  modal.classList.remove('modal--video');
  manageModalVideos();
  modalContent.innerHTML = '';
}


function loadOverlayHtml(link){
  var delay = 0;
  var overlayType = typeof link == 'string' ? link : link.dataset.overlay;
  var overlayHtml = ``;
  var reloadOverlayContent = true;
  switch(overlayType){
    case 'video':
      modal.classList.add('modal--video');
      manageModalVideos(link.dataset.videoId);
    break;
    case 'image':
      overlayHtml = imageOverlayHtml(link.dataset.imageUrl);
    break;
    case 'subscribe':
      // check to see if modal already has subscribe form
      const modalSubscribe = modalContent.querySelector('#modal-subscribe');
      if(modalSubscribe){
        reloadOverlayContent = false;
      } else {
        overlayHtml = subscribeOverlayHtml();
      }
      delay = 1000;
    break;
  }
  console.log(`overlayType:${overlayType}, reloadOverlayContent:${reloadOverlayContent}`);
  reloadOverlayContent && (modalContent.innerHTML = overlayHtml);
  return delay;
}

/*
function videoOverlayHtml(videoUrl){
    const modalHtml = videoEmbedHtml(videoUrl);
    return modalBoxTemplate(modalHtml,'video');
}

function videoEmbedHtml(videoUrl){
    let embedHtml = '';
    if( videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be') ){
      embedHtml = `
          <iframe  class="responsive-video" src="https://www.youtube.com/embed/${youtubeIdFromUrl(videoUrl)}?autoplay=1&loop=1&controls=2&modestbranding=1&rel=0" frameborder="0" allowfullscreen></iframe>
      `;
    } else if( videoUrl.includes('vimeo.com') ){
      embedHtml = `
        <iframe class="responsive-video" src="https://player.vimeo.com/video/${vimeoIdFromUrl(videoUrl)}?autoplay=1&loop=1&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>  
      `;
    } else if ( videoUrl.includes('.mp4') || videoUrl.includes('.MP4') ) {
      embedHtml = `
      <video class="responsive-video" controls loop autoplay="autoplay">
          <source src="${videoUrl}" type="video/mp4">
      </video>
      `;
    } else {
      // default iframe
      embedHtml = `
      <iframe class="responsive-video" src="${videoUrl}"></iframe> 
      `;
    }
  
    return `
    <div class="responsive-video-wrapper">
      ${embedHtml}
    </div>
    `;
}
*/

function modalBoxTemplate(payload,type){
  return `
      ${payload}
    
  `;
}

function youtubeIdFromUrl(url) {
    const pattern = /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/&]{10,12})/i;
    const matches = url.match(pattern);
    if (matches) {
        return matches[1];
    }
    return false;
}

function vimeoIdFromUrl(url) {
    const pattern = /(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/i;
    const matches = url.match(pattern);
    if (matches) {
        return matches[1];
    }
    return false;
}



// SUBSCRIBE OVERLAY
const subscribeOverlayCookie = readCookie('subscribeOverlayCookie');

if (!subscribeOverlayCookie && subscribeOverlayData.display ) {
  // show overlay 
  // set cookie, expires in one day
  createCookie('subscribeOverlayCookie', 'set', 1);
  
  // show overlay after a brief delay
  setTimeout(function(){
    // console.log('open subs');
    openOverlay('subscribe');
  },1000);

}

// overlay HTML
function subscribeOverlayHtml(){
  return `
  <div id="modal-subscribe" class="modal__subscribe centered bg--white pt-desktop-60 pr-desktop-80 pb-desktop-80 pl-desktop-80 pt-mobile-40 pr-mobile-20 pb-mobile-40 pl-mobile-20">
    <div class="modal__heading mb-desktop-40 mb-mobile-40">
      <h3 class="heading--ultra"><strong>${subscribeOverlayData.heading}</strong></h3>
    </div>
    ${subscribeOverlayData.embedCode ? `<div class="klaviyo-wrapper mt-desktop-40 mt-mobile-40">${subscribeOverlayData.embedCode}</div>` : ``}
  </div>
  `;
}


window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'submit') {
      // console.log('Klaviyo submit');
      const modalSubscribe = document.getElementById('modal-subscribe');
      if (modalSubscribe){
        modalSubscribe.classList.add('modal__subscribe--success');
        createCookie('subscribeOverlayCookie', 'set', 365);
        setTimeout(function(){
          closeOverlay();
        },6000);
      }
  }
});



// PRELOADED MODAL VIDEOS

// https://developer.vimeo.com/player/sdk/embed
// https://developer.vimeo.com/player/sdk/basics

// get video players to be accessed later
let videoPlayers = {};
let vimeoPlayers = 0;

initVideoPlayers = function (){
  var windowHeight = window.innerHeight ;
  var scrollPosition = window.scrollY || window.scrollTop || document.querySelector('html').scrollTop;
  // console.log(`initVideoPlayers(), scrollPosition:${scrollPosition}, windowHeight:${windowHeight}`);
  const videoElements = document.querySelectorAll('.vimeo-modal, .upload-modal, .youtube-modal');
  if(videoElements.length > 0){
      
      videoElements.forEach((videoElement)=>{
          // get type and video ID
          let player;
          const type = videoElement.dataset.type;
          const videoId = videoElement.dataset.id;

          // set up player by type
          if(type=='vimeo'){
            player = new Vimeo.Player(videoElement);
            player.setAutopause(false);
            player.setVolume(0);
            if(videoId == 'hero' || scrollPosition > windowHeight ){
              // play and pause so its ready to go
              player.play().then(function(loop) {
                // console.log(`vimeo paused: ${videoId}`);
                player.pause();
                player.setVolume(1);
              }).catch(e => {
                // console.log(`vimeo pause interrupted: ${videoId}`);
              });
            } else {
              setTimeout(function(){
                // console.log(`vimeo play: ${videoId}`);
                player.play().then(function(loop) {
                  // console.log(`vimeo play paused: ${videoId}`);
                  player.pause();
                  player.setVolume(1);
                }).catch(e => {
                });
              },3000);
            }

            vimeoPlayers ++;
          }
          if(type=='youtube'){
            player = new YT.Player(videoId, {});
          }
          if(type=='upload'){
            player = videoElement
          }
          // add player to array
          videoPlayers[videoId] = {
            type: type,
            id: videoId,
            player: player
          };
      });

      initVimeoVideos();
  }
}

var bufferTimeouts = {};
function setBufferFallbackTimeout(id){
  bufferTimeouts[id] = setTimeout(function(){
    console.log(`${id} timed activation`);
    activateLoadedLink(id);
  },1000);
}

function activateLoadedLink(id){
  const loadedVideoLink = document.querySelector('[data-video-id="'+id+'"]');
  if(loadedVideoLink){
    loadedVideoLink.classList.add('loaded');
  }
}

function initVimeoVideos(){
  // console.log(`initVimeoVideos() : ${vimeoPlayers} `);
  for( var videoId in videoPlayers ) {
    if(videoPlayers[videoId].type == 'vimeo' ){
      // console.log(`will init vimeo: ${videoId}`);
      setBufferFallbackTimeout(videoId);
      videoPlayers[videoId].player.on('bufferstart', ((id) => {
        return () => {
          console.log(`${id} bufferstart`);  
          clearTimeout(bufferTimeouts[id]);
        };
      })(videoId));
      videoPlayers[videoId].player.on('bufferend', ((id) => {
        return () => {
          console.log(`${id} bufferend`);  
          activateLoadedLink(id);
        };
      })(videoId));
    }
  }
}



const modalVideos = document.querySelectorAll('.modal__video');

function manageModalVideos(id=null) {
  if(modalVideos.length > 0){
      modalVideos.forEach(video=>{
        if(id){
          // ID passed, open video
          if(video.dataset.id == id){
            if( video.dataset.type == 'vimeo' ){
              videoPlayers[id].player.setCurrentTime(0);
              videoPlayers[id].player.play();
            }
            if( video.dataset.type == 'youtube' ){
              videoPlayers[id].player.seekTo(0);
              videoPlayers[id].player.playVideo();
            } 
            if( video.dataset.type == 'upload' ){
              videoPlayers[id].player.currentTime = 0;
              videoPlayers[id].player.play();
            }
            video.classList.add('modal__video--active');
          } else {
            video.classList.remove('modal__video--active');
          }
        } else {
          // no ID passed, close any open videos
          if(video.classList.contains('modal__video--active')){
            video.classList.remove('modal__video--active');
            if( video.dataset.type == 'youtube' ){
              videoPlayers[video.dataset.id].player.pauseVideo();
            } else {
              videoPlayers[video.dataset.id].player.pause();
            }
          }
        }
      });
  }
};

if(!waitForYouTubeAPI){
  initVideoPlayers();
}